import { ReactNode } from "react";
import { Link } from "react-router-dom";

/** Breadcrumb trail across the admin drill-down
 * (Enterprises → Enterprise → State → District). */
export function Crumbs({
  items,
}: {
  items: { label: string; to?: string }[];
}) {
  return (
    <nav className="text-sm text-gray-500 mb-3 flex flex-wrap items-center gap-1">
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1">
          {it.to ? (
            <Link to={it.to} className="hover:text-agrilens-green-dark">
              {it.label}
            </Link>
          ) : (
            <span className="text-gray-800 font-medium">{it.label}</span>
          )}
          {i < items.length - 1 && <span className="text-gray-300">/</span>}
        </span>
      ))}
    </nav>
  );
}

export function PageTitle({
  eyebrow,
  title,
  subtitle,
}: {
  eyebrow?: string;
  title: string;
  subtitle?: string;
}) {
  return (
    <div className="mb-4">
      {eyebrow && (
        <div className="text-xs uppercase tracking-wider text-gray-500">
          {eyebrow}
        </div>
      )}
      <h1 className="text-2xl font-semibold text-agrilens-green-dark">
        {title}
      </h1>
      {subtitle && <p className="text-sm text-gray-600">{subtitle}</p>}
    </div>
  );
}

export function Card({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) {
  return (
    <div className="bg-white rounded shadow p-4">
      {title && (
        <h3 className="text-sm font-semibold text-gray-700 mb-3">{title}</h3>
      )}
      {children}
    </div>
  );
}

export function ErrorNote({ error }: { error: unknown }) {
  if (!error) return null;
  const msg = error instanceof Error ? error.message : String(error);
  return (
    <div className="bg-red-50 text-red-700 text-sm rounded p-3">{msg}</div>
  );
}

export function Loading({ label = "Loading…" }: { label?: string }) {
  return <div className="text-gray-600 text-sm py-4">{label}</div>;
}
